import {toAbsoluteUrl} from "../../_helpers";
export function getInitLayoutConfig() {
  return {
    "demo": "demo1",
    "js": {
      "breakpoints": {
        "sm": 576,
        "md": 768,
        "lg": 992,
        "xl": 1200,
        "xxl": 1200
      },
      "colors": {
        "theme": {
          "base": {
            "white": "#ffffff",
            "primary": "#1BC5BD",
            "secondary": "#E5EAEE",
            "success": "#1BC5BD",
            "info": "#6993FF",
            "warning": "#FFA800",
            "danger": "#F64E60",
            "light": "#F3F6F9",
            "dark": "#212121"
          },
          "light": {
            "white": "#ffffff",
            "primary": "#1BC5BD",
            "secondary": "#ECF0F3",
            "success": "#C9F7F5",
            "info": "#E1E9FF",
            "warning": "#FFF4DE",
            "danger": "#FFE2E5",
            "light": "#F3F6F9",
            "dark": "#D6D6E0"
          },
          "inverse": {
            "white": "#ffffff",
            "primary": "#ffffff",
            "secondary": "#212121",
            "success": "#ffffff",
            "info": "#ffffff",
            "warning": "#ffffff",
            "danger": "#ffffff",
            "light": "#464E5F",
            "dark": "#ffffff"
          }
        },
        "gray": {
          "gray100": "#F3F6F9",
          "gray200": "#ECF0F3",
          "gray300": "#E5EAEE",
          "gray400": "#D6D6E0",
          "gray500": "#B5B5C3",
          "gray600": "#80808F",
          "gray700": "#464E5F",
          "gray800": "#1B283F",
          "gray900": "#212121"
        }
      },
      "fontFamily": "Poppins"
    },
    "loader": {
      "enabled": true,
      "type": "",
      "logo": "/media/logos/logo-dark-sm.png",
      "message": "Please wait..."
    },
    "toolbar": {
      "display": true
    },
    "header": {
      "self": {
        "width": "fluid",
        "theme": "light",
        "fixed": {
          "desktop": true,
          "mobile": true
        }
      },
      "menu": {
        "self": {
          "display": false,
          "layout": "tab",
          "root-arrow": false,
          "icon-style": "duotone"
        },
        "desktop": {
          "arrow": true,
          "toggle": "click",
          "submenu": {
            "theme": "light",
            "arrow": true
          }
        },
        "mobile": {
          "submenu": {
            "theme": "dark",
            "accordion": true
          }
        }
      }
    },
    "subheader": {
      "display": false,
      "displayDesc": false,
      "displayDaterangepicker": true,
      "layout": "subheader-v6",
      "fixed": false,
      "width": "fluid",
      "clear": false,
      "style": "solid",
      "breadcrumb": {
        "display": true
      }
    },
    "content": {
      "width": "fluid"
    },
    "brand": {
      "self": {
        "theme": "dark"
      }
    },
    "aside": {
      "self": {
        "theme": "dark",
        "display": true,
        "fixed": true,
        "minimize": {
          "toggle": true,
          "default": false,
          "hoverable": true
        }
      },
      "footer": {
        "self": {
          "display": true
        }
      },
      "menu": {
        "dropdown": false,
        "scroll": false,
        "icon-style": "duotone",
        "submenu": {
          "accordion": true,
          "dropdown": {
            "arrow": true,
            "hover-timeout": 500
          }
        }
      },
      "secondary": {
        "display": true
      }
    },
    "footer": {
      "self": {
        "fixed": true,
        "width": "fluid"
      },
      "width": "fixed",
      "fixed": true
    },
    "extras": {
      "search": {
        "display": false,
        "layout": "offcanvas",
        "offcanvas": {
          "direction": "right"
        }
      },
      "notifications": {
        "display": false,
        "layout": "offcanvas",
        "dropdown": {
          "style": "dark"
        },
        "offcanvas": {
          "directions": "right",
          "direction": "right"
        }
      },
      "quick-actions": {
        "display": true,
        "layout": "offcanvas",
        "dropdown": {
          "style": "dark"
        },
        "offcanvas": {
          "directions": "right",
          "direction": "left"
        }
      },
      "user": {
        "display": true,
        "layout": "offcanvas",
        "dropdown": {
          "style": "light"
        },
        "offcanvas": {
          "directions": "right",
          "direction": "left"
        }
      },
      "languages": {
        "display": false
      },
      "cart": {
        "display": false,
        "dropdown": {
          "style": "dark"
        },
        "layout": "dropdown",
        "offcanvas": {
          "direction": "dark"
        }
      },
      "quick-panel": {
        "display": true,
        "offcanvas": {
          "directions": "right",
          "direction": "left"
        }
      },
      "chat": {
        "display": true
      },
      "toolbar": {
        "display": true
      },
      "scrolltop": {
        "display": true
      }
    },
    "self": {
      "layout": "default",
      "body": {}
    }
  };
}
